import { searchComponent } from "../commons"

export default (state, indexes, component) => {
  const { currentEditMessage, currentEditSlidePage } = state
  // updateInfo: properties to update | indexInfo: if cannot regist component to `updateTargetComponent` to use this 
  const { messageIndex, rowIndex, componentIndex, slidePageIndex, rowIndexDetail } = indexes

  // 수정할 타겟을 구분하는 flag
  const editTargetFlag = (slidePageIndex || slidePageIndex === 0) && (rowIndexDetail || rowIndexDetail === 0) && (currentEditSlidePage || currentEditSlidePage === 0) 
  const editState = editTargetFlag ? 'SLIDE_PAGE' : 'MESSAGE'

  const procCallBack = (_component) => {
    return {
      ..._component,
      ...component
    }
  }

  // 수정 할 타겟 요소 파라미터
  const editTarget = editTargetFlag ? [currentEditSlidePage] : currentEditMessage
  // 수정 할 메시지 인덱스 파라미터
  const messageIndex_param = editTargetFlag ? 0 : messageIndex
  // 수정 할 Row 인덱스 파라미터 (as slide page)
  const rowIndex_param = editTargetFlag ? rowIndexDetail : rowIndex

  const editedTarget = searchComponent(procCallBack, editTarget, messageIndex_param, rowIndex_param, componentIndex)
  console.log('editedTarget :', editedTarget);
  // Update state
  if (editTargetFlag) {
    return {
      editState: editState,
      result: editedTarget ? editedTarget[0] : currentEditSlidePage, // else 케이스의 경우 수정하지 않음
    } 
  }

  return {
    editState: editState,
    result: editedTarget,
  } 
}